@if (activeSection$ | async; as activeSection) {
  @if (activeSection.tourId === OA_ADMIN_AREA.id) {
    @switch (activeSection.sectionId) {
      @case ('generalInfo') {
        <markant-platform-general-information></markant-platform-general-information>
      }
      @case ('myOrganization') {
        <markant-platform-my-organization></markant-platform-my-organization>
      }
      @case ('myEmployees') {
        <markant-platform-my-employees></markant-platform-my-employees>
      }
      @case ('myServices') {
        <markant-platform-my-services></markant-platform-my-services>
      }
      @case ('myGroups') {
        <markant-platform-my-groups></markant-platform-my-groups>
      }
    }
  }
}
@if (endDialogData$ | async; as endDialogData) {
  <markant-platform-modal-bridge>
    <markant-platform-section-finish-dialog
      [sectionData]="endDialogData"
    ></markant-platform-section-finish-dialog>
  </markant-platform-modal-bridge>
}
